import { requireFinancialAccess } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { Home } from 'lucide-react';
import { FinancialPage } from '../../../features/financial/components';
import { Page, PageHeader } from '../../../shared/ui/page';

export const Route = createFileRoute('/_app/financial/')({
  component: RouteComponent,
  beforeLoad: async () => {
    // 974/Demonstrativo: só Seguradora Admin/Comercial, Assessoria ou Corretor.
    const hasAccess = await requireFinancialAccess();
    if (!hasAccess) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function RouteComponent() {
  return (
    <Page.Root>
      <Page.Breadcrumb
        items={[
          {
            label: 'Pagina Inicial',
            href: '/dashboard',
            iconLeft: <Home className='h-4 w-4' />,
          },
          { label: 'Gestão Financeira', active: true },
        ]}
      />

      <PageHeader.Root>
        <PageHeader.Main>
          <PageHeader.TitleGroup>
            <PageHeader.Title>Gestão Financeira</PageHeader.Title>
            <PageHeader.Subtitle>
              Acompanhe e gerencie seus recebimentos e comissões
            </PageHeader.Subtitle>
          </PageHeader.TitleGroup>
        </PageHeader.Main>
      </PageHeader.Root>

      <FinancialPage />
    </Page.Root>
  );
}
